import { isMutatingOperation } from "./operations.js";
export const OPERATION_TRANSPORT_PROTOCOL_VERSION = 3;
export const LEGACY_OPERATION_TRANSPORT_PROTOCOL_VERSION = 2;
export const SUPPORTED_OPERATION_TRANSPORT_PROTOCOL_VERSIONS = [
    OPERATION_TRANSPORT_PROTOCOL_VERSION,
    LEGACY_OPERATION_TRANSPORT_PROTOCOL_VERSION
];
export const AUTHORIZATION_BINDING_PROTOCOL_VERSION = 5;
export const LEGACY_AUTHORIZATION_BINDING_PROTOCOL_VERSION = 4;
export const SUPPORTED_AUTHORIZATION_BINDING_PROTOCOL_VERSIONS = [
    AUTHORIZATION_BINDING_PROTOCOL_VERSION,
    LEGACY_AUTHORIZATION_BINDING_PROTOCOL_VERSION
];
export const SEMANTIC_CAPABILITY_CONTRACT_VERSION = 1;
export const DURABLE_MUTATION_CONTRACT_VERSION = 1;
export const CONNECT_CONTRACT_SUPPORT = {
    operation_transport: [...SUPPORTED_OPERATION_TRANSPORT_PROTOCOL_VERSIONS],
    authorization_binding: [...SUPPORTED_AUTHORIZATION_BINDING_PROTOCOL_VERSIONS],
    semantic_capabilities: [SEMANTIC_CAPABILITY_CONTRACT_VERSION],
    durable_mutation: [DURABLE_MUTATION_CONTRACT_VERSION]
};
/**
 * Produce the exact contract ceiling signed during authorization. `sync` is
 * conservatively mutation-capable because its action is selected per request.
 */
export function authorizationContractRequirements(operations, files, operationTransportRecovery = []) {
    const requirements = {
        operation_transport: OPERATION_TRANSPORT_PROTOCOL_VERSION,
        authorization_binding: AUTHORIZATION_BINDING_PROTOCOL_VERSION,
        semantic_capabilities: 1
    };
    const recovery = [...new Set(operationTransportRecovery)]
        .filter((version) => version !== OPERATION_TRANSPORT_PROTOCOL_VERSION)
        .sort((left, right) => right - left);
    if (recovery.length > 0)
        requirements.operation_transport_recovery = recovery;
    if (operations.some((operation) => isMutatingOperation(operation, { action: "mutate" }))
        || files?.actions.some((action) => action !== "list" && action !== "read") === true) {
        requirements.durable_mutation = 1;
    }
    return requirements;
}
export function supportsContractRequirements(required, supported, durableMutation) {
    return supported.operation_transport.includes(required.operation_transport)
        && (required.operation_transport_recovery ?? []).every((version) => supported.operation_transport.includes(version))
        && supported.authorization_binding.includes(required.authorization_binding)
        && supported.semantic_capabilities.includes(required.semantic_capabilities)
        && (!durableMutation
            || (required.durable_mutation !== undefined
                && supported.durable_mutation.includes(required.durable_mutation)));
}
export function isSupportedOperationTransport(version) {
    return SUPPORTED_OPERATION_TRANSPORT_PROTOCOL_VERSIONS
        .includes(version);
}
export function isSupportedAuthorizationBinding(version) {
    return SUPPORTED_AUTHORIZATION_BINDING_PROTOCOL_VERSIONS
        .includes(version);
}
export function permitsOperationTransport(contracts, version, recoveryOnly = false) {
    return contracts.operation_transport === version
        || (recoveryOnly
            && (contracts.operation_transport_recovery ?? []).includes(version));
}
